import _defineProperty from "C:/Users/jaros/Documents/Pinavo/WebApp/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */
import { containerPhrasing } from 'mdast-util-to-markdown/lib/util/container-phrasing.js';
import { track } from 'mdast-util-to-markdown/lib/util/track.js';
/** @type {FromMarkdownExtension} */

export var gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {
    strikethrough: enterStrikethrough
  },
  exit: {
    strikethrough: exitStrikethrough
  }
};
/** @type {ToMarkdownExtension} */

export var gfmStrikethroughToMarkdown = {
  unsafe: [{
    character: '~',
    inConstruct: 'phrasing'
  }],
  handlers: {
    delete: handleDelete
  }
};
handleDelete.peek = peekDelete;
/** @type {FromMarkdownHandle} */

function enterStrikethrough(token) {
  this.enter({
    type: 'delete',
    children: []
  }, token);
}
/** @type {FromMarkdownHandle} */


function exitStrikethrough(token) {
  this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */


function handleDelete(node, _, context, safeOptions) {
  var tracker = track(safeOptions);
  var exit = context.enter('emphasis');
  var value = tracker.move('~~');
  value += containerPhrasing(node, context, _objectSpread(_objectSpread({}, tracker.current()), {}, {
    before: value,
    after: '~'
  }));
  value += tracker.move('~~');
  exit();
  return value;
}
/** @type {ToMarkdownHandle} */


function peekDelete() {
  return '~';
}